import React from 'react';
import { Card, Crate, FlexCrate, Icon, Text } from '@perch-labs/shrike';
import { copyFor } from 'config';

const getCopy = copyFor('billing.statement.delayedCredit');

export const DelayedCredit: React.FC = () => {
  return (
    <Card mobileVariant="flat" margin={{ bottom: '32px' }}>
      <Card.Content>
        <FlexCrate>
          <Icon
            color="accent4"
            icon="LightningBolt"
            margin={{ top: '24px', bottom: '24px', right: '8px' }}
            scale={3.5}
          />
          <Crate>
            <Text
              textStyle="heading700"
              tag="h2"
              margin={{ top: '24px', bottom: '24px' }}
            >
              {getCopy('header')}
            </Text>
            <Text textStyle="paragraph500">{getCopy('content')}</Text>
          </Crate>
        </FlexCrate>
      </Card.Content>
    </Card>
  );
};
